import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}departments/`;

class DepartmentService {
  getAll(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  }
  getById(id) {
    return axios.get(`${API_URL}${id}`, {
      headers: buildHeaders(),
    });
  }
  create(departmentData) {
    return axios.post(API_URL, departmentData, {
      headers: buildHeaders(),
    });
  }
  update(id, departmentData) {
    return axios.put(`${API_URL}${id}`, departmentData, {
      headers: buildHeaders(),
    });
  }
  delete(id) {
    return axios.delete(`${API_URL}${id}`, {
      headers: buildHeaders(),
    });
  }
  exportReport(format, params = {}) {
    return axios.get(`${API_URL}report/export`, {
      params: { ...params, format },
      responseType: "blob",
      headers: buildHeaders(),
    });
  }

  downloadImportTemplate() {
    return axios.get(`${API_URL}import/template`, {
      responseType: "blob",
      headers: buildHeaders(),
    });
  }

  previewImport(file, mode = "create") {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("mode", mode);
    return axios.post(`${API_URL}import/preview`, fd, {
      headers: buildHeaders({}, { multipart: true }),
    });
  }

  applyImport(file, mode = "create") {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("mode", mode);
    return axios.post(`${API_URL}import/apply`, fd, {
      headers: buildHeaders({}, { multipart: true }),
    });
  }
}

export default new DepartmentService();
